document.addEventListener("DOMContentLoaded", function() {

    // Check if localStorage is available
    LSChecker = function() {
        try {
            typeof window.localStorage;
            return true;
        } catch(e) {
            return false;
        }
    }

    // Frontpage - Laptop slider
    if (document.querySelector('.display-carousel')) {
        $('.display-carousel').slick({
            infinite: false,
            speed: 300,
            arrows: false,
            dots: false,
            fade: true,
            cssEase: 'linear',
            accessibility: false,
            swipe: false,
            touchMove: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand'
        });
        $(".header-mockups .navigation a").click(function (e) {
            e.preventDefault();
            $('.display-carousel').slick('slickGoTo', parseInt($(this).index()), false);
        });
    }

    // Landing page - testimonial slider
    if (document.querySelector('.section-testimonials')) {
        var sliderFor = $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav'
        });
        var sliderNav = $('.slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        // Pause slider when mouseover .slider-for
        $('.slider-for').mouseover(function () {
            sliderNav.slick('slickPause');
        });
        $('.slider-for').mouseout(function () {
            sliderNav.slick('slickPlay');
        });
    }


    // Smooth scrolling using jQuery easing
    document.querySelectorAll('a.js-scroll-trigger[href*="#"]:not([href="#"])').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (location.pathname.replace(/^\//, '') == e.currentTarget.pathname.replace(/^\//, '') && location.hostname == e.currentTarget.hostname) {
                let target = document.querySelector(e.currentTarget.hash);
                target = target ? target : document.querySelector('[name=' + e.currentTarget.hash.slice(1) + ']');
                if (target) {
                    const targetPosition = target.getBoundingClientRect().top + window.scrollY - 136;
                    window.scroll({ top: targetPosition, behavior: 'smooth' });
                    return false;
                }
            }
        });
    });

    // Scrollspy
    if (document.querySelector('.navbar-special')) {
        new bootstrap.ScrollSpy(document.querySelector('#scrollspy-wrapper'), {
            target: '.navbar-special',
            rootMargin: '-138px 0px -100% 0px',
            threshold: [0]
        });

        if (document.querySelector('#scrollspy-wrapper-2')) {
            new bootstrap.ScrollSpy(document.querySelector('#scrollspy-wrapper-2'), {
                target: '.navbar-special',
                rootMargin: '-138px 0px -100% 0px',
                threshold: [0]
            });
        }
    }

    // Enable tooltips
    if (document.querySelector('[data-bs-toggle="tooltip"]')) {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }

    if (document.querySelector('[data-bs-toggle="show-discount"]')) {
        const tooltipDiscount = new bootstrap.Tooltip('[data-bs-toggle="show-discount"]', {
            container: '.fieldset-switcher',
            trigger: 'manual'
        });
        tooltipDiscount.show();
    }

    // Enable popovers
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {
        container: 'body'
    }));

    // Enable custom popovers
    const popoverCustomList = document.querySelectorAll('[data-bs-toggle="custom-popover"]');
    const popoverCList = [...popoverCustomList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {
        container: 'body',
        trigger: 'focus',
        placement: function (context, source) {
            if (window.outerWidth <= 991) { return "top"; }
            return "left";
        }
    }));

    // Pricing frontend;
    const pricingSwitcher = document.querySelectorAll('.pricing-switcher input[name="period"]');
    pricingSwitcher.forEach((period) => period.addEventListener('change', function(event) {
        const planValue = event.target.value;
        // -- Pricing page
        const listPrices = document.querySelectorAll('.list-prices .pricing-price-value');
        listPrices.forEach((list) => list.textContent = '$' + list.dataset[planValue]);
    }));

    // Typed.js
    if (document.querySelector('.typed')) {
        new Typed('.typed', {
            strings: ["statusCode:500 && country:US && !browser:chrome"],
            typeSpeed: 100,
            backDelay: 1000,
            loop: false,
            showCursor: false
        });
    }

    if (document.querySelector('.typed_2')) {
        new Typed('.typed_2', {
            strings: ["var logger = new Elmahio({<br/>&nbsp;&nbsp;apiKey: 'API_KEY',<br/>&nbsp;&nbsp;logId: 'LOG_ID'<br/>});<br/><br/>logger.information('Hello World from the browser');<br/><br/>try {<br/>&nbsp;&nbsp;throw new Error('Some error');<br/>} catch(err) {<br/>&nbsp;&nbsp;logger.error('An error happened', err);<br/>}"],
            typeSpeed: 60,
            backDelay: 1000,
            loop: false,
            showCursor: false
        });
    }

    // Animations Demo - Slack page
    if(document.querySelector('.actions-demo')) {
        document.querySelector('.action-success').addEventListener('click', function(el) {
            el.currentTarget.classList.add('zoomIn', 'animated');
            el.currentTarget.querySelector('span').classList.add('fa', 'fa-check');
            el.currentTarget.querySelector('span').innerHTML = '';
        });

        document.querySelector('.action-hide').addEventListener('click', function(el) {
            el.currentTarget.classList.add('fadeOut', 'animated', 'delay-1s');
            el.currentTarget.querySelector('span').innerHTML = 'Hidden';
        });

        document.querySelector('.action-delete').addEventListener('click', function(el) {
            el.currentTarget.classList.add('zoomOut', 'animated', 'delay-1s');
            el.currentTarget.querySelector('span').innerHTML = 'Deleted';
        });

        // reload animations
        document.querySelector('.action-redo').addEventListener('click', function(el) {
            document.querySelector('.action-success').classList.remove('zoomIn', 'animated');
            document.querySelector('.action-success span').classList.remove('fa', 'fa-check');
            document.querySelector('.action-success span').innerHTML = document.querySelector('.action-success span').dataset.text;

            document.querySelector('.action-hide').classList.remove('fadeOut', 'animated', 'delay-1s');
            document.querySelector('.action-hide span').innerHTML = document.querySelector('.action-hide span').dataset.text;

            document.querySelector('.action-delete').classList.remove('zoomOut', 'animated', 'delay-1s');
            document.querySelector('.action-delete span').innerHTML = document.querySelector('.action-delete span').dataset.text;
        });
    }

    // navbar background color change on scroll
    function navbarScroll() {
        const scroll = window.scrollY || document.documentElement.scrollTop
        const navbarOverlap = document.querySelector('.navbar-overlap');
        const navbarDark = document.querySelector('.navbar-dark');

        if (scroll < 10) {
            if (navbarOverlap) { navbarOverlap.classList.remove('dark-mode'); }
            if (navbarDark) { navbarDark.classList.remove('dark-mode'); }
        } else {
            if (navbarOverlap) { navbarOverlap.classList.add('dark-mode'); }
            if (navbarDark) { navbarDark.classList.add('dark-mode'); }
        }
    }
    // On window scroll
    window.addEventListener('scroll', function() {
        navbarScroll();
    });
    navbarScroll();

    // Home / Pricing pages - popup signup book
    if (document.querySelector('.popup-signup') || document.querySelector('.modal-exitIntent')) {
        window.addEventListener('CookiebotOnAccept', function (e) {
            if (Cookiebot.consent.preferences) {
                // Show popup
                if (document.querySelector('.popup-signup')) {
                    if (LSChecker()) {
                        if (localStorage.getItem('PopupSignupShow') === null) {
                            localStorage.setItem('PopupSignupShow', 'true');
                            setTimeout(function(){ 
                                document.querySelector(".popup-signup").classList.remove('popup-hidden');
                            }, 10000);
                        } else {
                            if (localStorage.getItem('PopupSignupShow') === 'true') {
                                setTimeout(function(){
                                    document.querySelector(".popup-signup").classList.remove('popup-hidden');
                                }, 10000);
                            } else {
                                document.querySelector(".popup-signup").remove();
                            }
                        }
                    } else {
                        setTimeout(function(){
                            document.querySelector(".popup-signup").classList.remove('popup-hidden');
                        }, 10000);
                    }

                    // Close popup signup
                    if (document.querySelector(".close-popup-signup")) {
                        document.querySelector(".close-popup-signup").addEventListener("click", function() {
                            const popupSignup = document.querySelector('.popup-signup');
                            popupSignup.classList.add("popup-close");
                            setTimeout(() => {
                                popupSignup.classList.add('popup-hidden');
                                popupSignup.classList.remove('popup-close');
                                if (LSChecker()) {
                                    localStorage.setItem('PopupSignupShow', 'false');
                                }
                            }, 400);
                        });
                    }
                }

                // Exit intent modal
                const mouseEventOut = function(e) {
                    if (!e.toElement && !e.relatedTarget) {
                        document.removeEventListener('mouseout', mouseEventOut);
                        
                        // show modal intent
                        const exitIntentModal = new bootstrap.Modal('.modal-exitIntent');
                        exitIntentModal.show();

                        // Set the cookie when the popup is shown to the user
                        localStorage.setItem("exitIntentShown", true);
                    }
                };

                if (window.localStorage && !localStorage.getItem('exitIntentShown') && document.querySelector('.modal-exitIntent')) {
                    document.addEventListener('mouseout', mouseEventOut);
                }
            }
        }, false);
    }

    // expand docs & exceptions
    document.querySelectorAll('.sidebar .main-nav > li > a').forEach(elem => {
        elem.addEventListener('click', (event) => {
            if (window.innerWidth < 768) {
                event.currentTarget.parentElement.querySelector('ul').classList.toggle('d-block');
            }
        });
    });

    // add intercom link class to links
    document.querySelectorAll("a[href*='javascript:Intercom']").forEach((link) => link.classList.add('intercom-link'));

    // remove intercom localStorage when document ready
    if (window.localStorage) {
        for (let i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,8) == 'intercom') {
                localStorage.removeItem(localStorage.key(i));
            }
        }
    }

    // remove intercom sessionStorage when document ready
    if (window.sessionStorage) {
        sessionStorage.removeItem('intercom.draft');
    }

    document.querySelectorAll('.intercom-link').forEach(elem => {
        elem.addEventListener('click', function(e) {
            if (document.querySelector('#intercom-facade-btn')) {
                e.preventDefault();
                document.querySelector('#intercom-facade-btn > div').dispatchEvent(new Event('mouseenter'));
                var counter = 0;
                var interval = setInterval(function () {
                    counter++;
                    if (window.Intercom && window.Intercom.booted) {
                        var params = null;
                        if (e.target.href) {
                            var regExp = /\(([^)]+)\)/;
                            var matches = regExp.exec(e.target.href)[1];
                            matches = matches.replaceAll('\'', '');
                            params = matches.split(/(?:,|$)\s*/g);
                        } else {
                            params = [];
                            var objData = { ...e.target.dataset };
                            Object.keys(objData).forEach(key => {
                                params.push(objData[key]);
                            });
                        }
                        Intercom.apply(null, params);
                        clearInterval(interval);
                    } else if (counter > 10) {
                        clearInterval(interval);
                    }
                }, 100);
            } else if (window.Intercom && window.Intercom.booted) {
                var params = null;
                if (e.target.href) {
                    var regExp = /\(([^)]+)\)/;
                    var matches = regExp.exec(e.target.href)[1];
                    matches = matches.replaceAll('\'', '');
                    params = matches.split(/(?:,|$)\s*/g);
                } else {
                    params = [];
                    var objData = { ...e.target.dataset };
                    Object.keys(objData).forEach(key => {
                        params.push(objData[key]);
                    });
                }
                Intercom.apply(null, params);
            } else {
                window.location.href = "/contact/";
            }
        });
    });

    // Init Fancybox library
    if (document.querySelector("[data-fancybox]")) {
        Fancybox.bind("[data-fancybox]", {
            idle: false
        });
    }
});

// Tools navbar
if (document.querySelector('.navbar-tools')) {
    document.querySelectorAll('.tools-nav li').forEach((elem) => {
        const anchor = elem.querySelector('a');
        const href = anchor.getAttribute('href');
        if (window.location.pathname.indexOf(href) !== -1) {
            anchor.classList.add('active');
        }
    });
}

if (document.querySelector('.navbar-special')) {
    var hash = document.location.hash;
    window.location.hash = '';
}

// On window loaded
window.addEventListener('load', function() {
    if (hash) {
        var element = hash ? document.getElementById(hash.substr(1)) : null;
        if (element !== null) {
            const targetPosition = element.getBoundingClientRect().top + window.scrollY - 136;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        }
    }
});

window.intercomSettings = {
    app_id: "i2hhgdvj",
    system: "elmah.io",
    background_color: "#0da58e"
};